import { Badge } from "@mantine/core";
import { type Tender } from "../../../api/tenders";

interface StageBadgeProps {
  stage: Tender["stage"];
}

const stageConfig = {
  DRAFT: { color: "gray", label: "Draft" },
  PENDING_APPROVAL: { color: "yellow", label: "Pending Approval" },
  PUBLISHED: { color: "blue", label: "Published" },
  COLLECTION: { color: "yellow", label: "Collection" },
  OPENED: { color: "orange", label: "Opened" },
  TECH_EVAL: { color: "purple", label: "Technical Evaluation" },
  FIN_EVAL: { color: "indigo", label: "Financial Evaluation" },
  EVALUATION_COMPLETE: { color: "cyan", label: "Evaluation Complete" },
  AWARDED: { color: "green", label: "Awarded" },
  EXPIRED: { color: "red", label: "Expired" },
};

export function StageBadge({ stage }: StageBadgeProps) {
  const config = stageConfig[stage];

  if (!config) {
    // Fallback for unknown stages
    return (
      <Badge color="gray" variant="light">
        {stage || "Unknown"}
      </Badge>
    );
  }

  return (
    <Badge color={config.color} variant="light">
      {config.label}
    </Badge>
  );
}
